// 시즌패스 페이지 카피 (연 1회 · 39,000원) — Gemini 초안 검수·제품 정렬
export const seasonPackCopy = {
  eyebrow: 'Season Pass',
  title: '2026 입시 시즌패스',
  lede:
    '일본 학부 입시 시즌에 맞춰 할 일과 공식 확인 링크를 묶어 드립니다. 강의가 아니라, 회차·공고를 놓치지 않게 정리하는 연 1회 패스입니다.',
  priceLabel: '연 1회 · 39,000원',
  priceNote:
    '결제: PayPal 또는 계좌 이체. 신청이 오면 메일로 안내합니다. 사이트에 계좌번호는 올리지 않습니다. 확인 후 액션팩·패스 알림을 시작합니다.',
  includes: [
    '시즌 액션팩: 시기별 필수 확인 항목과 공식 웹사이트 링크',
    '패스 태그 알림: 무료 알림보다 구체적인 회차·공고 확인 리마인더',
    '프린트용 팩 페이지: 결제 확인 후 안내되는 액션팩 열람·인쇄',
    '시즌 기간 Q&A 메일 1회 (일정·사이트 이용 범위)',
  ],
  excludes: [
    '1:1 대면·화상 입시 컨설팅 세션 (별도 90분 컨설팅)',
    '대학별 원서 대리 작성·제출 대행',
    '기간 제한 없는 무제한 질의응답',
    '합격·장학금 수혜 보장',
    '무료 가이드·체크리스트·캘린더·알림의 페이월',
  ],
  prepare: [
    '목표 전형(EJU / 일반 / 국비)과 관심 시즌',
    '안내·결제를 받을 이메일 주소',
    '가능하면 관심 대학·학부 후보 (없어도 신청 가능)',
  ],
  process: [
    '아래 양식을 제출하거나 완성 문구를 복사해 메일로 보냅니다.',
    '2~3영업일 내 PayPal 또는 계좌 이체 안내 메일을 받습니다.',
    '결제 확인 후 액션팩 링크와 패스 알림 등록 안내를 받습니다.',
  ],
  policy: [
    '결제 전 취소: 결제 없음 → 별도 환불 없음',
    '결제 후 · 액션팩/패스 메일 최초 발송 전: 전액 환불 검토',
    '액션팩·패스 메일 제공 후: 원칙 환불 불가 (디지털 상품)',
    '유효 기간: 2026 입시 시즌패스(해당 연도 시즌 안내 범위)',
  ],
  formIntro:
    '신청은 결제 확정이 아닙니다. 「신청 보내기」로 전달하거나, 미리보기 문구를 복사해 메일로 보내도 됩니다.',
  disclaimer:
    '본 서비스는 입시 정보 정리·일정 알림 도구입니다. 각 대학 모집요강과 JASSO·대사관·DNC 등 공식 공고 원문이 최우선이므로, 출원 전 반드시 원문을 직접 확인하세요. 합격은 보장하지 않습니다.',
};
